import {
  DriverVehicleTabs,
  useDriverVehicleTab,
} from '../components/driver-vehicle-tabs'
import { ActivitiesFileArchive } from './ActivitiesFileArchive'
import { VehicleActivitiesFileArchive } from './VehicleActivitiesFileArchive'

export const FileArchive: React.FC = () => {
  const [tab, setTab] = useDriverVehicleTab()
  const tabs = <DriverVehicleTabs tab={tab} onChange={setTab} />

  return tab === 'vehicle' ? (
    <VehicleActivitiesFileArchive tabs={tabs} />
  ) : (
    <ActivitiesFileArchive tabs={tabs} />
  )
}
